import React from "react";
import CountUp from "react-countup";
import Link from "next/link";
import { getAssets } from "@unisearch/helpers";
import Grid from "@mui/material/Grid";
import styles from "./hero.module.scss";

export const UniPageDiversifyHero = () => {
  return (
    <section className={styles.section_hero}>
      <div className="container">
        <Grid container spacing={3} alignItems="center">
          <Grid item sm={12} md={5}>
            <h5 className={styles.sub_head}>
              Over a Million Prospects in Emerging Student
            </h5>
            <h1 className={styles.title}>Markets Through A Single Platform</h1>
            <p className={`${styles.sub_title} font-medium`}>
              UniSearch is built to equip our university partners with better
              understanding of and access to unique target audiences in emerging
              source markets.
            </p>

            <div className={styles.button_wrapper}>
              <Link legacyBehavior href="/university/booking">
                <a className="btn btn-bg btn-secondary">Book for Demo</a>
              </Link>
            </div>

            <div className={styles.counter_wrapper}>
              <ul>
                <li>
                  <div className={styles.number}>
                    <CountUp end={4500} duration={2} />+
                  </div>
                  <div className={styles.text}>vetted recruiters</div>
                </li>
                <li>
                  <div className={styles.text2}>Reach new markets</div>
                  <div className={styles.divider}></div>
                  <div className={styles.text3}>Recruit at scale</div>
                </li>
              </ul>
            </div>
          </Grid>
          <Grid item sm={12} md={7}>
            <div className={styles.image_wrapper}>
              <img
                src={getAssets("assets/images/unipage/uni_markets.png")}
                alt="University markets"
              />
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default UniPageDiversifyHero;
